export default {
  updateIsDisabledAddToCart(state, val) {
    state.isDisabledAddToCart = val;
  },
};
